import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { uiActions } from "../../store/ui-slice";
import { useEffect } from "react";
import { getTokenInfo } from "../../utils/Guard";
import { documenttypeActions } from "../../store/documenttype-store/documenttype-slice";
import { InputTextarea } from "primereact/inputtextarea";

let restartPage = false;

const DocumenttypeForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const documenttype = useSelector((state)=>state.documenttype.documenttype)
  const isValid = useSelector(
    (state) => state.documenttype.documenttypeValidation
  );
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);

  const onChangeHandler = (id, value) => {
    dispatch(documenttypeActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(documenttypeActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(documenttypeActions.setFieldValid({ id, value: false }));
    }
  };
  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      documenttype.id > 0 &&
      restartPage
    ) {
      dispatch(documenttypeActions.restartState());
      window.location.href = "/documenttype";
    }
  }, [documenttype.id, dispatch, navigate, notification]);

  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (documenttype.name === "") {
      dispatch(documenttypeActions.setFieldValid({ id: "name", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    
    }
    else if (documenttype.code === "") {
      dispatch(documenttypeActions.setFieldValid({ id: "name", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else {
      dispatch(props.actionDocumenttype(documenttype, userInfo.Email));
      restartPage = true;
    }
  };
  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Nombre:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {documenttype && documenttype.name && documenttype.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={documenttype.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="code" style={{ fontSize: "large", color: "" }}>
                Código:
              </label>
              <InputText
                id="Code"
                value={documenttype.code}
                onChange={(e) => onChangeHandler("code", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("code")}</div>
            </div>
            <div className="field col-12 md:col-12">
              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="Description"
                rows={5}
                value={documenttype.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("description")}</div>
            </div>
            <div className="field col-12 md:col-8"></div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/documenttype");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default DocumenttypeForms;
